






































import Vue from 'vue'


import GatewayEmpty from './GatewayEmpty.vue'
import Summary from './Summary.vue'
import Dmp from './Dmp.vue'
import Terminal from './Terminal.vue'
import Connection from './Connection.vue'
import Desktop from './Desktop.vue'
import dayjs from "dayjs";
import {nanoid} from "@/utils/nanoidUtil"


export default Vue.extend({
  components: {
    GatewayEmpty,
    Summary,
    Dmp,
    Terminal,
    Connection,
    Desktop,
  },
  props: {
    gateway:{
      type: Object,
      default: undefined
    },
    tenants:{}
  },
  data() {
    return {
      curremtName: 'Summary',
      compoentKey: 'juhy'
    }
  },
  computed: {
    gatewayCode(){
      return this.gateway?.code || '--'
    },
    gatewayIsOnline(){
      return this.gateway?.isOnline || false
    },
    lastOnlineTime(){
      return this.gateway && this.gateway.lastOnlineTime ?
          dayjs(this.gateway.lastOnlineTime).format("YYYY-MM-DD HH:mm:ss") : '--'
    },
    lastOfflineTime(){
      return this.gateway && this.gateway.lastOfflineTime ?
          dayjs(this.gateway.lastOfflineTime).format("YYYY-MM-DD HH:mm:ss") : '--'
    },
    hardwareType(){
      return this.gateway?.hardwareType || ''
    },
    desktopDisabled(){
      return !(this.hardwareType === 'mtpad_android')
    }
  },
  mounted() {
    
  },
  created() {
  },
  destroyed() {
  },
  methods: {
    onTabChange(activeKey){
      this.curremtName= activeKey;
    },
    initCurremt(){
      this.curremtName = 'Summary'
    },
    resetTabKey(){
      this.curremtName = 'Summary'
      this.compoentKey = nanoid()
      // this.curremtName = ''
      // setTimeout(()=>{
      //   this.curremtName = 'Summary'
      // },100)
    }
  },
  watch:{
    gateway:{
      handler(newVal,oldVal){
        if (oldVal === undefined){
          return
        }
        if (newVal.code != oldVal.code){
          this.resetTabKey()
        }
        // console.log('new gateway:', newVal);
      }
    }
  }
})
